import React from 'react';
import { type FieldValues, type Path, useController, useFormContext } from 'react-hook-form';
import { Typography, TypographyVariant } from 'components/Typography';
import Markdown from 'components/Markdown';
import { getTypographyForMarkdown } from 'lib/getTypographyForMarkdown';
import './fieldError.css';

const typographyForMarkdown = getTypographyForMarkdown(TypographyVariant.BodyXxs);

interface InputError<T extends FieldValues> {
  name: Path<T>;
}

const FieldError = <T extends FieldValues>({ name }: InputError<T>) => {
  const { control } = useFormContext<T>();
  const {
    fieldState: { error }
  } = useController({ name, control });

  if (!error?.message) return null;

  return (
    <Typography variant={TypographyVariant.BodyXxs}>
      <div className="fieldError">
        <Markdown content={error.message} renderers={typographyForMarkdown} />
      </div>
    </Typography>
  );
};

export default FieldError;
